class Storage {
  storage: any;
  KEYS: any;

  constructor(type: string) {
    let storageType = type;
    if (storageType !== 'localStorage' && storageType !== 'sessionStorage') {
      // default to storage with smaller impact/lifetime
      storageType = 'sessionStorage';
    }

    try {
      // accessing the variable may lead to SecurityExceptions
      this.storage = window[storageType];
    } catch (e) {
      this.storage = {};
    }

    this.KEYS = {};

    if (storageType === 'localStorage') {
      this.KEYS = {}; // Todo: need to add localStorage keys here as n when required
    } else if (storageType === 'sessionStorage') {
      this.KEYS = {
        browserTabId: 'co:browserTabId',
        wasBrowserTabUnloaded: 'co:wasTabUnloaded',
        onceDailyNotifications: 'co:onceDailyNotifications',
      };
    }
  }

  set(key: string, value: any) {
    try {
      // web storage saves any given value as string
      // JSON.stringify saves it in the correct way to be able to retrieve booleans/numbers/objects on getter
      this.storage.setItem(key, btoa(JSON.stringify(value)));
      return true;
    } catch (exception) {
      return false;
    }
  }

  get(key: string) {
    try {
      // web storage provides any given value as string
      // JSON.parse will retrieve booleans/numbers/objects correctly (if value was stringified correctly before)
      return JSON.parse(atob(this.storage.getItem(key)));
    } catch (exception) {
      return '';
    }
  }

  remove(key: string) {
    try {
      this.storage.removeItem(key);
      return true;
    } catch (exception) {
      return false;
    }
  }
}

export const session = new Storage('sessionStorage');
export const local = new Storage('localStorage');
